import { IonContent, IonPage, IonSpinner } from "@ionic/react";
import React from "react";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import {
  clearSigningSession,
  rememberLoginReturnPath,
  restoreSigningSessionIfMatchingRoute,
} from "../helpers/signing-session";
import { initPushNotifications } from "../services/pushNotifications";
import store, { RootState } from "../store";
import UserSession from "./UserSession";

export default function (ComposedComponent: any) {
  class RequireAuth extends React.Component<any, any> {
    constructor(props: any) {
      super(props);
      this.state = {
        logoutUser: false,
      };

      restoreSigningSessionIfMatchingRoute(
        this.props.match?.params,
        this.props.location?.pathname,
      );
      this.setUserData();
    }

    setUserData() {
      if (UserSession.exists()) {
        UserSession.setUserData(this.props)
          .then((data: any) => {
            if (!data.success) {
              rememberLoginReturnPath(this.props.location?.pathname);
              clearSigningSession();
              window.sessionStorage.removeItem("authId");
              window.sessionStorage.removeItem("userId");
              store.dispatch({ type: "app/RESET_APP" });
              this.setState({ logoutUser: true });
            } else if (
              data.success &&
              store.getState().user.id &&
              this.props.history
            ) {
              initPushNotifications(this.props.history);
            }
          })
          .catch(() => false);
      }
    }

    render() {
      if (this.state.logoutUser) {
        return <Redirect to="/login" />;
      }

      const loggedIn = this.props.userId > 0;

      if (!loggedIn) {
        if (!UserSession.exists()) {
          rememberLoginReturnPath(this.props.location?.pathname);
          return <Redirect to="/login" />;
        }

        /* Session token finns men Redux har inte hydrerats än — visa inte /projects-redirect
           (den bröt djupa länkar som /projects/:id). */
        return (
          <IonPage>
            <IonContent className="page-wrapper">
              <IonSpinner name="crescent" color="primary" />
            </IonContent>
          </IonPage>
        );
      }

      return <ComposedComponent {...this.props} />;
    }
  }

  const mapStateToProps = (state: RootState) => ({
    userId: state.user.id,
  });

  return connect(mapStateToProps)(withRouter(RequireAuth));
}
